<template>
<v-app>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="color_header_myorder" :style="{background: bg_color}">
            <div class="d-flex justify-space-between align-center pa-3">
                <div class="d-flex align-center">
                    <div class="img_cart_header_myorder">
                        <img src="@/assets/spoonandforkcircle.png">
                    </div>
                    <div class="ml-2 color_title_myorder">ออเดอร์ของฉัน</div>
                </div>
                <div class="link_back_myorder" @click="$router.push('/'+$route.params.type +'/'+$route.params.id+'/'+$route.params.token)" v-if="$route.params.id !== 'home'">
                    <div>
                        <v-icon color="white" size="30">mdi-close</v-icon>
                    </div>
                </div>
                <div class="link_back_myorder" @click="$router.push('/'+$route.params.type)" v-if="$route.params.id === 'home'">
                    <div>
                        <v-icon color="white" size="30">mdi-close</v-icon>
                    </div>
                </div>
            </div>
        </div>
        <div class="detail_myorder">
            <div class="d-flex justify-space-between align-center mt-2 mb-2">
                <div class="d-flex">
                    <div class="d-flex align-center">
                        <div class="mr-1 food_table_myorder"></div>
                        <div>ทานที่ร้าน</div>
                    </div>
                    <div class="d-flex align-center ml-4 mr-4">
                        <div class="mr-1 food_table_takehome_myorder"></div>
                        <div>กลับบ้าน</div>
                    </div>
                </div>
                <div>
                    ราคารวม ฿ {{ resultPrice }}
                </div>
            </div>

            <v-expansion-panels>
                <v-expansion-panel class="mt-2 header_panel_myorder" v-for="(order_detail,key) in order_list" :key="key">
                    <v-expansion-panel-header :class="order_detail.status == 0 ? 'color_font_history_myorder' : 'color_font_history_takehome_myorder'">
                        <div>Order # {{ order_detail.order}} ( {{ order_detail.status == 0 ? 'ทานที่ร้าน' : 'กลับบ้าน'}} )
                            <v-chip color="orange" dark
                                    v-if="order_detail.count_unsuccess > 0 && setting_type_food.status_process_food == 1">รอเสิร์ฟ</v-chip>
                                <v-chip
                                    v-else-if="order_detail.count_unsuccess == 0 && setting_type_food.status_process_food == 1"
                                    color="primary" dark>เสิร์ฟทั้งหมดแล้ว</v-chip>
                        </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="body_food_myorder">
                        <v-card color="#eeeeee" class="pa-3 d-flex align-center mt-2" v-for="(history_detail,list_history_key) in order_detail.listDetaile" :key="list_history_key">
                            <div class="d-flex justify-space-between align-center w_full_myorder">
                                <div class="d-flex align-center">
                                    <div class="mr-2 pa-3 amount_food_myorder">{{ history_detail.amount }}</div>
                                    <div>{{ history_detail.food }} <v-chip
                                        v-if="history_detail.status_process_food == 0 && setting_type_food.status_process_food == 1"
                                        class="ml-2" color="orange" dark>รอเสิร์ฟ</v-chip><v-chip
                                        v-if="history_detail.status_process_food == 1 && setting_type_food.status_process_food == 1"
                                        class="ml-2" color="success" dark>เสิร์ฟแล้ว</v-chip>
                                        <div class="topping_food_myorder">
                                            <ul>
                                                <li v-for="(topping_name_list,key_topping) in history_detail.listTop" :key="key_topping">
                                                    <span v-if="topping_name_list.amount" class="amount_list_topping_myorder">{{ topping_name_list.amount }}</span> {{ topping_name_list.topingName }}
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="note_myorder" v-if="history_detail.description">
                                            หมายเหตุ : {{ history_detail.description }}
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    ฿ {{ history_detail.pricePerUnit }}
                                </div>
                            </div>
                        </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>
    </div>
</v-app>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
export default {
    name: 'myOrder',
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            bg_color: 'linear-gradient(to top, #038cc1 , #55c0e9)',
            order_list: [],
            setting_type_food: {},
            resultPrice:0,
        }
    },
    methods: {
        async settingRestaurantDetail() {
            this.loading_page = true
            HTTP.get('/setup/restaurant', {
                headers: {
                    "Authorization": `Bearer ${this.$store.state.token}`
                }
            })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.setting_type_food = response.data.setup
                        this.loading_page = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async colorRestaurant() {
            HTTP.get('/showColor')
                .then((response) => {
                    if (response.data.successful === true) {
                        this.bg_color = response.data.color_code
                        this.loading_page = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                    if (error.response.status === 500) {
                        this.$router.push('/nametakeoutuser')
                    }

                })
        },
        async myOrderDetail() {
            HTTP.get('/customer/order-list/' + this.$route.params.id, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.order_list = response.data.orderList
                        this.resultPrice = response.data.resultPrice
                        this.loading_page = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                    if (error.response.status === 500) {
                        this.$router.push('/thankyouuser')
                    }

                })
        },
    },
    created() {
        HTTP.get('/POS/table/check_token_opentable/' + this.$route.params.id + '/' + this.$route.params.token, {
                headers: {
                    "Authorization": `Bearer ${this.$store.state.token}`
                }
            })
            .then((response) => {
                if (response.data.successful === false) {
                    this.$store.commit('clearCartListUser')
                    this.$store.commit('clearCartTakeOutTableListUser')
                    this.$store.commit('clearCartListUserTakeOut')
                    this.$store.commit('clearCartOrderOnlineUser')
                    this.$router.push('/thankyouuser')
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
                if (error.response.status === 500) {
                    this.$store.commit('clearCartListUser')
                    this.$store.commit('clearCartTakeOutTableListUser')
                    this.$store.commit('clearCartListUserTakeOut')
                    this.$store.commit('clearCartOrderOnlineUser')
                    this.$router.push('/thankyouuser')
                }

            })
    },
    mounted() {
        this.settingRestaurantDetail()
        this.colorRestaurant()
        this.myOrderDetail()
    }
}
</script>

<style scoped>
.color_header_myorder {
    background: linear-gradient(to top, #038cc1, #55c0e9);
    position: fixed;
    width: 100%;
    z-index: 10;
}

.img_cart_header_myorder {
    width: 50px;
}

.img_cart_header_myorder>img {
    max-width: 100%;
}

.color_title_myorder {
    color: #fff;
}

.link_back_myorder {
    cursor: pointer;
}

.detail_myorder {
    height: 100%;
    padding: 100px 12px 70px !important
}

.header_panel_myorder.v-expansion-panel::before {
    box-shadow: unset !important;
    -webkit-box-shadow: unset !important;
}

.header_panel_myorder,
.color_font_history_myorder,
.color_font_history_takehome_myorder {
    font-size: 20px !important;
}

.color_font_history_myorder {
    border: 1px #4caf50 solid;
    background: #4caf50;
    color: #ffffff !important;
}

.color_font_history_myorder>>>i {
    color: #ffffff !important;
}

.color_font_history_takehome_myorder {
    border: 1px #2e8b57 solid;
    background: #2e8b57;
    color: #ffffff !important;
}

.color_font_history_takehome_myorder>>>i {
    color: #ffffff !important;
}

.body_food_myorder>.v-expansion-panel-content__wrap {
    padding: 0 !important;
}

.theme--light.v-expansion-panels .v-expansion-panel>>>.v-expansion-panel-content__wrap {
    padding: 0;
}

.amount_food_myorder {
    background: #fff;
}

.topping_food_myorder {
    font-size: 16px;
}

/* .amount_list_topping_myorder{
    color: #ff5252;
} */

.note_myorder {
    color: #ff5252;
}

.food_table_myorder {
    padding: 15px;
    background: #4caf50;
    border-radius: 20px;
}

.food_table_takehome_myorder {
    padding: 15px;
    background: #2e8b57;
    border-radius: 20px;
}

.food_takehome_myorder {
    padding: 15px;
    background: #2f4f4f;
    border-radius: 20px;
}

.food_cart_myorder {
    padding: 15px;
    background: linear-gradient(to top, #038cc1, #55c0e9);
    border-radius: 20px;
}

.w_full_myorder {
    width: 100%;
}
</style>
